export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_20.a79790c5.jpg";